<aura-dialog-layout title="Créer un nouveau Plan" [hideCancel]="true">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" dialog-content class="flex flex-col gap-4 w-full">
    @if (errorMessage()) {
      <div class="p-3 bg-red-3 border border-red-8 text-red-11 rounded text-sm">
        {{ errorMessage() }}
      </div>
    }

    <mat-form-field class="w-full">
      <mat-label>Nom du plan</mat-label>
      <input matInput formControlName="name" placeholder="Ex: ETXE Pro (Monthly)" autocomplete="off" />
      @if (form.get('name')?.hasError('required')) {
        <mat-error>Le nom est requis</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Slug (Identifiant unique en BDD)</mat-label>
      <input matInput formControlName="slug" placeholder="Ex: pro" autocomplete="off" />
      @if (form.get('slug')?.hasError('required')) {
        <mat-error>Le slug est requis</mat-error>
      }
      @if (form.get('slug')?.hasError('pattern')) {
        <mat-error>Le slug doit contenir uniquement des lettres minuscules, chiffres et tirets</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>ID de Produit Stripe existant (facultatif)</mat-label>
      <input
        matInput
        formControlName="stripeProductId"
        placeholder="Ex: prod_R123abc... (laisser vide pour créer)"
        autocomplete="off"
      />
    </mat-form-field>

    <div class="flex gap-4">
      <mat-form-field class="flex-1">
        <mat-label>Tarif (EUR)</mat-label>
        <input
          type="number"
          matInput
          formControlName="price"
          placeholder="Ex: 79"
          min="0"
          autocomplete="off"
        />
        @if (form.get('price')?.hasError('required')) {
          <mat-error>Le prix est requis</mat-error>
        }
        @if (form.get('price')?.hasError('min')) {
          <mat-error>Le prix doit être positif</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label>Cycle de facturation</mat-label>
        <mat-select formControlName="billingCycle">
          <mat-option value="monthly">Mensuel</mat-option>
          <mat-option value="quarterly">Trimestriel</mat-option>
          <mat-option value="yearly">Annuel</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex items-center my-2">
      <mat-checkbox formControlName="isActive"> Rendre ce plan immédiatement actif </mat-checkbox>
    </div>

    <mat-form-field class="w-full">
      <mat-label>Fonctionnalités incluses</mat-label>
      <mat-select formControlName="features" multiple>
        @for (feature of availableFeatures; track feature.value) {
          <mat-option [value]="feature.value">{{ feature.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>

  <div dialog-actions class="flex justify-end gap-3 w-full">
    <button mat-button type="button" [disabled]="isLoading()" (click)="onCancel()">Annuler</button>
    <button
      mat-flat-button
      class="primary"
      type="submit"
      [disabled]="form.invalid || isLoading()"
      (click)="onSubmit()"
    >
      @if (isLoading()) {
        Création en cours...
      } @else {
        Créer le plan
      }
    </button>
  </div>
</aura-dialog-layout>
